import { ArrowLeft, ShieldX } from 'lucide-react';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Terminal screen after the realtime channel closed 4403: a moderator removed this
 * participant. No auto-rejoin; the only way out is back to the home screen.
 */
export function RemovedScreen(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-foreground">
      <div
        data-testid="removed-screen"
        className="flex w-full max-w-md flex-col items-center gap-4 rounded-2xl border border-red-500/30 bg-zinc-900/60 p-8 text-center shadow-2xl shadow-black/50"
      >
        <div className="grid h-12 w-12 place-items-center rounded-full bg-red-500/15">
          <ShieldX className="h-6 w-6 text-red-300" />
        </div>
        <h1 className="text-xl font-semibold text-zinc-100">{t('room.removed_title')}</h1>
        <p className="text-sm text-zinc-400">{t('room.removed_body')}</p>
        <a
          href="/"
          className="mt-2 flex items-center gap-1.5 rounded-full bg-zinc-800 px-4 py-2 text-sm font-medium text-zinc-100 transition-colors hover:bg-zinc-700"
        >
          <ArrowLeft aria-hidden className="h-3.5 w-3.5" />
          {t('room.back_home')}
        </a>
      </div>
    </main>
  );
}
